var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"color":"blue","depressed":"","dark":"","height":"40"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t("warehouse.release"))+" "),_c('v-icon',{staticClass:"ml-2"},[_vm._v("mdi-arrow-right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }